var _clipPath;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRadio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-60.0221,-137.532)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ArtBoard3",
    transform: "matrix(0.977457,0,0,1.25045,7.0317,13.9822)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.213,
    y: 98.805,
    width: 102.306,
    height: 79.971,
    style: {
      fill: "none"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.213,
    y: 98.805,
    width: 102.306,
    height: 79.971
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.199817,0,0,0.156194,54.2125,82.8466)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(8.38329,0,0,8.3681,-2337.45,-12759.7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M301.614,1586.48C302.177,1586.48 318.127,1586.43 318.647,1586.37C321.282,1586.06 323.364,1584.98 324.894,1583.13C326.725,1580.92 327.64,1577.77 327.64,1573.68C327.64,1569.6 326.725,1566.46 324.894,1564.25C323.364,1562.41 321.282,1561.34 318.647,1561.04C318.127,1560.98 302.177,1560.98 301.614,1560.98C298.198,1560.98 295.568,1562.08 293.723,1564.28C291.879,1566.48 290.956,1569.63 290.956,1573.71C290.956,1577.79 291.879,1580.94 293.723,1583.16C295.568,1585.38 298.198,1586.48 301.614,1586.48ZM339.897,1573.68C339.897,1579.66 338.011,1584.77 334.24,1589.02C330.767,1592.92 325.638,1595.03 318.853,1595.34C318.269,1595.37 302.264,1595.41 301.655,1595.41C293.976,1595.41 288.251,1593.29 284.48,1589.04C280.708,1584.8 278.823,1579.69 278.823,1573.71C278.823,1567.84 280.708,1562.74 284.48,1558.43C288.251,1554.13 293.976,1551.97 301.655,1551.97C302.51,1551.97 318.748,1551.97 319.554,1552.03C325.993,1552.45 330.888,1554.58 334.24,1558.41C338.011,1562.72 339.897,1567.81 339.897,1573.68Z",
    style: {
      fill: "rgb(250,125,24)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(32.9541,0,0,32.9541,-3849.15,233.273)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 123.206,
    cy: 5.353,
    r: 2.061,
    style: {
      fill: "rgb(250,125,24)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6.8025,0,0,6.8025,-498.003,425.133)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 123.206,
    cy: 5.353,
    r: 2.061,
    style: {
      fill: "rgb(250,125,24)",
      stroke: "rgb(250,125,24)",
      strokeWidth: "2.51px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6.99918,0.0374582,0.0343628,6.79753,-402.009,130.955)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.893,-1.448L82.755,16.18C82.755,16.18 67.999,19.789 70.727,16.787C72.736,14.577 115.893,-1.448 115.893,-1.448Z",
    style: {
      fill: "rgb(250,125,24)",
      stroke: "rgb(250,125,24)",
      strokeWidth: "0.2px"
    }
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadio);
export default __webpack_public_path__ + "static/media/radio.f9def1db63f9604d76bc77ced2e51d92.svg";
export { ForwardRef as ReactComponent };